import {
  Container,
  Box,
  Typography,
  Paper,
  Button,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';

export default function DeleteAccountPage() {
  return (
    <Box sx={{ fontFamily: `'Inter', 'Roboto', sans-serif` }}>
      {/* Section: Header */}
      <Box sx={{ width: '100vw', py: 8 }}>
        <Container maxWidth="md">
          <Box textAlign="center">
            <Typography variant="h3" fontWeight={700} gutterBottom>
              Delete Your Account
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
              We’re sorry to see you go. If you'd like to delete your account, please contact us
              using the instructions below.
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Section: Instructions */}
      <Box sx={{ width: '100vw', bgcolor: '#f9f9f9', py: 6 }}>
        <Container maxWidth="md">
          <Paper
            variant="outlined"
            sx={{
              p: 4,
              borderRadius: 3,
              boxShadow: 1,
              bgcolor: '#ffffff',
              lineHeight: 1.7,
            }}
          >
            <Typography variant="h5" fontWeight={600} gutterBottom>
              How to Request Account Deletion
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              To delete your account, please email us at the address below with your username or the email address associated with your account. We will process your request within 7 days.
            </Typography>

            <Button
              variant="contained"
              color="primary"
              startIcon={<EmailIcon />}
              href="mailto:admin@nonleaguelive.uk"
              sx={{ mt: 2 }}
            >
              Email Us to Delete Account
            </Button>
          </Paper>
        </Container>
      </Box>
    </Box>
  );
}
